import React, { useState, useMemo } from "react";
import moment from "moment";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import { Paper } from "@mui/material";
import DateRangePickerComponent from "../components/common/custom-date-range-picker.component";

// ⛳ Replace this with your actual picker component

const organizationData = [
  { name: "Org A", status: "Active", date: "2025-07-20" },
  { name: "Org A", status: "Deactivated", date: "2025-07-21" },
  { name: "Org A", status: "Active", date: "2025-07-22" },

  { name: "Org B", status: "Suspended", date: "2025-07-19" },
  { name: "Org B", status: "Active", date: "2025-07-22" },

  { name: "Org C", status: "Denied", date: "2025-07-18" },
  { name: "Org C", status: "For Approval", date: "2025-07-19" },
  { name: "Org C", status: "For Approval", date: "2025-07-20" },

  { name: "Org D", status: "Active", date: "2025-07-15" },
  { name: "Org D", status: "Suspended", date: "2025-07-20" },
  { name: "Org D", status: "Deactivated", date: "2025-07-20" },
  { name: "Org D", status: "For Approval", date: "2025-07-22" },
  { name: "Org D", status: "Denied", date: "2025-07-23" },
  { name: "Org D", status: "Active", date: "2025-07-23" },
  { name: "Org D", status: "Denied", date: "2025-07-23" },
];

// Build a list of unique statuses and orgs
const allStatuses = ["Active", "Deactivated", "Suspended", "For Approval", "Denied"];

const transformByStatus = (data) => {
  const result = {};

  data.forEach(({ name, status }) => {
    if (!result[status]) result[status] = { status };
    if (!result[status][name]) result[status][name] = 0;
    result[status][name] += 1;
  });

  return allStatuses.map(status => result[status] || { status });
};

const OrganizationStatusChart = () => {
  const [startDate, setStartDate] = useState(moment().startOf("month"));
  const [endDate, setEndDate] = useState(moment().endOf("month"));

  const handleDateRangeChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const chartData = useMemo(() => {
    const filtered = organizationData.filter(item => {
      const d = moment(item.date);
      return d.isSameOrAfter(startDate, "day") && d.isSameOrBefore(endDate, "day");
    });

    return transformByStatus(filtered);
  }, [startDate, endDate]);

  // Get all org names (needed for coloring bars)
  const allOrgs = [...new Set(organizationData.map(d => d.name))];

  const colors = {
    "Org A": "#4caf50",
    "Org B": "#2196f3",
    "Org C": "#ff9800",
    "Org D": "#f44336",
  };

  return (
    <Paper elevation={3} style={{ padding: 24 }}>
      <DateRangePickerComponent
        initialStartDate={startDate}
        initialEndDate={endDate}
        ranges={{
          "Today": [moment().startOf("day"), moment().endOf("day")],
          "Last 7 Days": [moment().subtract(6, "days").startOf("day"), moment().endOf("day")],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
          "Last 90 Days": [moment().subtract(89, "days").startOf("day"), moment().endOf("day")],
        }}
        onDateRangeChange={handleDateRangeChange}
      />

      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData}>
          <XAxis dataKey="status" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          {allOrgs.map(org => (
            <Bar key={org} dataKey={org} fill={colors[org] || "#8884d8"} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default OrganizationStatusChart;
